var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifGeofenceExited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 21,
    rx: 5.5,
    fill: "#F0A311",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 21,
    rx: 5.5,
    stroke: "#F0A311"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13212_72847)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13212_72847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9328 9.15885L16.262 7.49219H14.4245V8.32552H15.9203L16.7536 9.15885H13.3828C12.3411 9.15885 11.5078 9.99219 11.5078 11.0339C11.5078 12.0755 12.3411 12.9089 13.3828 12.9089C14.3078 12.9089 15.0745 12.2339 15.2245 11.3547L16.1078 10.8255C16.0911 10.8964 16.0911 10.963 16.0911 11.0339C16.0911 12.0755 16.9245 12.9089 17.9661 12.9089C19.0078 12.9089 19.8411 12.0755 19.8411 11.0339C19.8411 9.99219 19.0078 9.15885 17.9661 9.15885M14.3578 11.3505C14.2161 11.7714 13.8328 12.0755 13.3703 12.0755C13.094 12.0755 12.8291 11.9658 12.6337 11.7704C12.4384 11.5751 12.3286 11.3101 12.3286 11.0339C12.3286 10.7576 12.4384 10.4926 12.6337 10.2973C12.8291 10.1019 13.094 9.99219 13.3703 9.99219C13.837 9.99219 14.2161 10.3005 14.3578 10.7214H13.1745V11.3464L14.3578 11.3505ZM17.9536 12.0755C17.6774 12.0755 17.4124 11.9658 17.2171 11.7704C17.0217 11.5751 16.912 11.3101 16.912 11.0339C16.912 10.7576 17.0217 10.4926 17.2171 10.2973C17.4124 10.1019 17.6774 9.99219 17.9536 9.99219C18.2299 9.99219 18.4949 10.1019 18.6902 10.2973C18.8856 10.4926 18.9953 10.7576 18.9953 11.0339C18.9953 11.3101 18.8856 11.5751 18.6902 11.7704C18.4949 11.9658 18.2299 12.0755 17.9536 12.0755Z",
    fill: "#F0A311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8594 14.2556H17.6768M17.6768 14.2556L16.8197 13.3984M17.6768 14.2556L16.8197 15.1127",
    stroke: "#F0A311",
    strokeWidth: 0.428571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_13212_72847",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8359 15.8132C16.0168 16.0295 15.9892 16.3532 15.7603 16.5179C14.8013 17.2079 13.6809 17.6457 12.5024 17.7865C11.1544 17.9476 9.78876 17.7132 8.57165 17.112C7.35453 16.5107 6.33849 15.5686 5.64727 14.4002C4.95604 13.2319 4.61946 11.8877 4.6785 10.5315C4.73754 9.17526 5.18966 7.86545 5.97981 6.76158C6.76995 5.65772 7.86402 4.80742 9.12878 4.31423C10.3935 3.82105 11.7744 3.70626 13.1033 3.98385C14.2651 4.22654 15.3432 4.76002 16.2386 5.53072C16.4523 5.71471 16.4517 6.03961 16.2526 6.23937C16.0536 6.43913 15.7316 6.43778 15.5155 6.25647C14.7622 5.62418 13.8623 5.18572 12.8944 4.98354C11.7595 4.74645 10.58 4.84449 9.49981 5.26572C8.41957 5.68695 7.48512 6.4132 6.81025 7.35602C6.13539 8.29883 5.74923 9.41754 5.6988 10.5759C5.64837 11.7343 5.93585 12.8823 6.52623 13.8802C7.11661 14.8781 7.98441 15.6828 9.02396 16.1963C10.0635 16.7098 11.2299 16.91 12.3812 16.7724C13.363 16.6551 14.2976 16.2965 15.103 15.7321C15.334 15.5703 15.6549 15.5969 15.8359 15.8132Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.8359 15.8132C16.0168 16.0295 15.9892 16.3532 15.7603 16.5179C14.8013 17.2079 13.6809 17.6457 12.5024 17.7865C11.1544 17.9476 9.78876 17.7132 8.57165 17.112C7.35453 16.5107 6.33849 15.5686 5.64727 14.4002C4.95604 13.2319 4.61946 11.8877 4.6785 10.5315C4.73754 9.17526 5.18966 7.86545 5.97981 6.76158C6.76995 5.65772 7.86402 4.80742 9.12878 4.31423C10.3935 3.82105 11.7744 3.70626 13.1033 3.98385C14.2651 4.22654 15.3432 4.76002 16.2386 5.53072C16.4523 5.71471 16.4517 6.03961 16.2526 6.23937C16.0536 6.43913 15.7316 6.43778 15.5155 6.25647C14.7622 5.62418 13.8623 5.18572 12.8944 4.98354C11.7595 4.74645 10.58 4.84449 9.49981 5.26572C8.41957 5.68695 7.48512 6.4132 6.81025 7.35602C6.13539 8.29883 5.74923 9.41754 5.6988 10.5759C5.64837 11.7343 5.93585 12.8823 6.52623 13.8802C7.11661 14.8781 7.98441 15.6828 9.02396 16.1963C10.0635 16.7098 11.2299 16.91 12.3812 16.7724C13.363 16.6551 14.2976 16.2965 15.103 15.7321C15.334 15.5703 15.6549 15.5969 15.8359 15.8132Z",
    stroke: "#F0A311",
    strokeWidth: 2,
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-1_13212_72847)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13212_72847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white",
    transform: "translate(4.67188 3.83594)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13212_72847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(10.6719 5.83594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifGeofenceExited);
export default __webpack_public_path__ + "static/media/notif-geofence-exited.7f4c152e9f4d03e9b3bcd7f7b465a64d.svg";
export { ForwardRef as ReactComponent };